export const dockFiveSixFormTextObj = {
  dockType: '设备类型',
  selectedDockFile: '生成文件类型',
  dock6FDrill_towSideConHole: '通孔分双面打通',
  dock56FDrill_twoSideConSlot: '通槽分双面打通',
  non_holes_not_files: '矩形板没有孔槽不输出文件',
  front_file_identifier: '正面文件标识',
  opposite_file_identifier: '反面文件标识',
  arc_description: '圆弧描述方式',
  split_slot: '宽槽拆解为多条窄槽加工',
  single_width: '拆解后单条槽宽度',
  output56FDrillLayoutDir: '板件长边摆放方向',
  is_output56FDrillLayoutDir: '板件长边摆放方向选择框',
  selectedOutput56DrillSoltDir: '五/六面钻槽或异形放置方向选择框',
  output56FDrillSlotDir: '五/六面钻槽或异形放置方向',
  output56FDrillDecimalNum: '坐标值保留位数',
  is_front_edge_fixed: '前封边摆放方向',
  front_edge_fixed_direction: '固定在',
  isNotMergeSlot: '相邻的等宽等深槽拉通处理',
  adjacentSize: '相邻尺寸小于等于',
  long_edge_rotate_range: '板件长边≤',
  automation: '桦桦自动线',
  plank_name_placement: {
    is_open: '指定板件名摆放',
  },
  welding_plate_placement: {
    enable: '焊接板原边固定靠夹手',
    direction: '焊接板夹手所在方向',
  },
  smallPlankCondition: {
    longSide: '长边',
    shortSide: '短边',
  },

  output5FDrillSlotKnifeCode: 'XML2铣槽刀具编号',
  output5FDrillShapeKnifeCode: 'XML2铣型刀具编号',
  output5FDrillNormalTexdirCode: 'XML2板件纹理-横纹=',
  output5FDrillReverseTexdirCode: 'XML2板件纹理-竖纹=',
  output5FDrillShapeKnifeOffset: 'XML2铣型刀具补偿',

  dock6FDrill_code: 'ban格式文件包含Code信息',
  utf8bom: '输出bom格式文件',
  dock6FDrill_plankHeight: '板件高度描述',
  dock6FDrill_plankCode: '板号描述',
  dock6FDrill_zValue: '反面槽Z坐标',
  dock6FOutputMprFile: '文件类型',
  dock56FDrillMprConHoleDir: 'mpr侧面孔Z坐标基准面',
  plankPlacement: '板件摆放方式',
  fixtureSetting: {
    fixtureDirection: '夹手所在方向',
    fixtureWidth: '夹手宽度(W)',
    fixtureLength: '夹手长度(H)',
    machineMaxWidth: '设备可加工的最大宽度',
  },
  slotEdge0Comp: '距边为0的槽边补偿',
  inner_shape_compensation_by_margin_le_0: '距边为0的内部异形边补偿',
  slotNoEdge0Comp: '距边不为0的槽边补偿',
  internal_cut_inside: '内部异形切割下刀和收刀均在板件内侧',
  external_cut_outside: '外部异形切割下刀和收刀均在板件外侧',
  cut_path_extension: '外部异形切割时，包含异形的整条边缘将同步切割',
  cut_path_extension_mode: '外部异形切割时，包含异形的整条边缘将同步切割',
}

export const dockFiveSixFormValueObj = {
  fixtureSetting: {
    fixtureDirection: '夹手所在方向',
    fixtureWidth: '夹手宽度(W)',
    fixtureLength: '夹手长度(H)',
    machineMaxWidth: '设备可加工的最大宽度',
  },
  plank_name_placement: {
    is_open: {
      true: '开启',
      false: '关闭',
    },
  },
  welding_plate_placement: {
    enable: {
      true: '开启',
      false: '关闭',
    },
    direction: {
      left: '左侧',
      right: '右侧',
      front: '前侧',
      back: '后侧',
    },
  },
  smallPlankCondition: {
    longSide: '长边',
    shortSide: '短边',
  },
  plankPlacement: {
    1: '自动避让夹手',
    2: '手动设置避让',
    3: '固定前封边',
    4: '固定长封边靠夹手边',
  },
  fixtureDirection: {
    left: '左边',
    right: '右边',
    front: '前边',
    back: '后边',
  },
  arc_description: {
    line_points: '线段成型描述',
    arc_command: '圆弧指令描述',
  },
  output56FDrillLayoutDir: {
    Horizontal: '横向',
    Vertical: '纵向',
  },
  output56FDrillSlotDir: {
    default: '系统默认',
    frontLeft: '前和左',
    frontRight: '前和右',
    backLeft: '后和左',
    backRight: '后和右',
  },
  dock6FDrill_zValue: {
    0: '-(板厚-槽深)',
    1: '-(槽深)',
  },
  front_edge_fixed_direction: {
    left: '左边',
    right: '右边',
    front: '前边',
    back: '后边',
  },
  // dock6FOutputMprFile: {
  //   mpr: '旧版MPR',
  //   newMpr: '新版MPR',
  // },
  dock56FDrillMprConHoleDir: {
    false: '板件上表面',
    true: '板件下表面',
  },
  cut_path_extension_mode: {
    all: '所有外异形',
    arc: '仅外圆弧异形',
  },
}
